import * as Sentry from '@reapit-sales/sentry-provider'
import { setMixpanelUserIdentity, resetMixpanelAnalytics } from '../analytics'

interface User {
  id: string
  email: string
  username?: string
}

let mixpanelIdentified = false
let sentryUserSet = false

export const UserIdentificationUtility = {
  /**
   * Ensures that the user is identified in Mixpanel and Sentry.
   * This function can be called after user logs in or when user data is available.
   * @param user - The user object containing id and other relevant details.
   */
  setUserIdentity: (user: User): void => {
    // --- Mixpanel ---
    if (!mixpanelIdentified && user && user.email) {
      try {
        setMixpanelUserIdentity(user.email, {
          $name: user.username || '',
          $userId: user.id || '',
          // Add any other relevant user properties here
        })
        mixpanelIdentified = true
      } catch (error) {
        console.error('Error identifying Mixpanel user:', error)
        // Optionally, handle the error (e.g., send to an error reporting service)
      }
    } else if (mixpanelIdentified) {
      // User is already identified in Mixpanel
    } else if (!user || !user.email) {
      console.warn('Mixpanel: User Email is missing, cannot identify.')
    }

    // --- Sentry ---
    if (!sentryUserSet && user && user.id) {
      try {
        Sentry.setUser({
          id: user.id,
          email: user.email || '',
          username: user.username || '',
          // Add any other relevant user data for Sentry
        })
        sentryUserSet = true
      } catch (error) {
        console.error('Error setting Sentry user:', error)
        // Optionally, handle the error
      }
    } else if (sentryUserSet) {
      // User is already set in Sentry
    } else if (!user || !user.id) {
      console.warn('Sentry: User ID is missing, cannot set user.')
    }
  },

  /**
   * Resets the identified user status for Mixpanel and Sentry.
   * This should be called on user logout.
   */
  clearUserIdentity: (): void => {
    // --- Mixpanel ---
    try {
      resetMixpanelAnalytics() // Resets distinct_id and clears super properties
      mixpanelIdentified = false
    } catch (error) {
      console.error('Error clearing Mixpanel identification:', error)
    }

    // --- Sentry ---
    try {
      Sentry.setUser(null) // Clears the user context in Sentry
      sentryUserSet = false
    } catch (error) {
      console.error('Error clearing Sentry user:', error)
    }
  },

  // Optional: Functions to check status if needed elsewhere
  isMixpanelUserIdentified: (): boolean => mixpanelIdentified,
  isSentryUserSet: (): boolean => sentryUserSet,
}
